// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7e7d6451","496":"43604ab7"}[chunkId] + ".chunk.js";
};